exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.printTemplatesRow {\n  margin-right: -25%;\n}\n.printTemplatesRow .subtitle {\n  font-weight: 500;\n  margin: 0;\n}\n.printTemplatesRow p:first-child {\n  margin: 0px;\n}\n.printTemplatesRow div {\n  margin: 7px 0;\n}\n.printTemplatesRow b {\n  font-weight: 500;\n}\n.printTemplatesRow span.title {\n  font-weight: 400;\n  font-size: 13px;\n  color: #78849e;\n}\n", ""]);

// exports
